import { render, staticRenderFns } from "./Relationship.vue?vue&type=template&id=d38db4c8&scoped=true"
import script from "./Relationship.vue?vue&type=script&lang=js"
export * from "./Relationship.vue?vue&type=script&lang=js"
import style0 from "./Relationship.vue?vue&type=style&index=0&id=d38db4c8&prod&scoped=true&lang=css"
import style1 from "./Relationship.vue?vue&type=style&index=1&id=d38db4c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38db4c8",
  null
  
)

export default component.exports